/* global productId, productFormId */
const form = document.getElementById("custom-recharge-form");
// Use a local mutable product id instead of reassigning the read-only global
let currentProductId = typeof productId !== 'undefined' ? parseInt(productId) : null;
const quantityInput = document.getElementById("recharge-quantity");
const quantityElement = document.getElementById("custom-recharge-form-quantity");
const summaryElement = document.getElementById("custom-recharge-form-summary");
const priceElement = document.getElementById("custom-recharge-form-price");
const save_text = document.getElementById("custom-recharge-form-saving")

let config = { childList: true };
let radioContainer = document.getElementById("custom-recharge-form-radios");
let checkedRadio = radioContainer ? radioContainer.querySelector('input[type="radio"]:checked') : null;

let quantity;

const linkedProductsSelect = document.getElementById('linked-product-select');

let targetNode = null;
let select = null;

if(quantityInput){
    quantity = parseInt(quantityInput.value);

    targetNode = document.getElementsByClassName("recharge-subscription-widget")[0].getElementsByTagName("DIV")[0];

    let observer = new MutationObserver(function (mutationsList) {
        for (let mutation of mutationsList) {
            if (mutation.type === "childList") {
                select = targetNode.querySelector('select[name="rc_selling_plan"]');
                if (select) {
                    let options = select.options;
                    radioContainer.innerHTML = "";

                    for (let i = 0; i < options.length; i++) { // Création des radio butons en fonction du select Recharge
                        let option = options[i];

                        let divWrapper = document.createElement("div");
                        divWrapper.className = "custom-recharge-form-radio"

                        let radio = document.createElement("input");
                        radio.type = "radio";
                        radio.name = "selling_plan";
                        radio.value = option.value;
                        radio.setAttribute("form", productFormId);
                        radio.id = "recharge-frequency-" + i;
                        if (i === options.length - 1)
                            radio.checked = true;

                        let label = document.createElement("label");
                        label.innerHTML = option.text + ((i === options.length - 1)? ' (Standard)' : ' (Extra contrôle des odeurs)');
                        label.setAttribute("for", "recharge-frequency-" + i);


                        divWrapper.appendChild(radio);
                        divWrapper.appendChild(label);
                        radioContainer.appendChild(divWrapper);
                    }

                    observer.disconnect();
                }
            }
        }
    });

    observer.observe(targetNode, config);

} else if(linkedProductsSelect){
    quantity = parseInt(linkedProductsSelect.options[linkedProductsSelect.selectedIndex].dataset.nb);
}

// Formater un prix (centimes → devise du store)
function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' kr.';
}

// Fonction pour mettre à jour les détails en fonction des inputs
function updateFormDetails() {
    if(quantityInput){
        quantity = parseInt(quantityInput.value);
    } else if(linkedProductsSelect){
        quantity = parseInt(linkedProductsSelect.options[linkedProductsSelect.selectedIndex].dataset.nb);
    }

    // Trouver le groupe de radios visible et le radio coché
    const visibleGroup = radioContainer.querySelector('.custom-recharge-form-radios:not(.hidden)');
    const checkedFrequency = visibleGroup ? visibleGroup.querySelector('input[type="radio"]:checked') : null;

    let frequencyLabel = "";
    if (checkedFrequency) {
        frequencyLabel = checkedFrequency.parentElement.querySelector('label').textContent.trim();
    }

    // Prix dynamiques depuis le produit sélectionné dans le dropdown
    if (linkedProductsSelect) {
        const selectedOption = linkedProductsSelect.options[linkedProductsSelect.selectedIndex];
        const price = parseInt(selectedOption.dataset.price);
        const comparePrice = parseInt(selectedOption.dataset.comparePrice);

        if (comparePrice && comparePrice > price) {
            priceElement.innerHTML = `<span class="compare-price">${formatMoney(comparePrice)}</span> ${formatMoney(price)}`;
            save_text.style.display = "block";
        } else {
            priceElement.innerHTML = `${formatMoney(price)}`;
            save_text.style.display = "none";
        }
    }

    // Texte
    let frequencyText = frequencyLabel.replace("Livraison", "livrés");
    const quantityText = `${quantity} sac${quantity > 1 ? 's' : ''} Pacha`;
    const summaryText = `${quantity} sac${quantity > 1 ? 's' : ''} de litière ${frequencyText}`;

    quantityElement.textContent = quantityText;
    summaryElement.textContent = summaryText;
}

form.addEventListener("change", updateFormDetails);

// Mettre à jour les prix dès le chargement de la page
if (linkedProductsSelect) {
    updateFormDetails();
}

// Fonction pour mettre à jour le select Recharge en fonction du radio custom checked
function updateSelectFromRadio() {
    if (targetNode) {
      select = targetNode.querySelector('select[name="rc_selling_plan"]');
    }
    checkedRadio = radioContainer ? radioContainer.querySelector('input[type="radio"]:checked') : null;

    if (checkedRadio && select) {
        select.value = checkedRadio.value;
        let changeEvent = new Event('change', {
            bubbles: true,
            cancelable: true
        });
        // Déclenche l'événement "change" sur le select pour changer l'url avec le selling_plan (comportement normal de Recharge)
        select.dispatchEvent(changeEvent);
    }
}

if(quantityInput){
  radioContainer.addEventListener("change", updateSelectFromRadio);
}

let checkoutButton = document.querySelector('[checkout-button]');

if(checkoutButton) {
    checkoutButton.addEventListener('click', goCheckout);
}

function goCheckout(redirect = true) {
    checkedRadio = radioContainer.querySelector('input[type="radio"]:checked');

    if (checkedRadio) {

        const quantityToSubmit = linkedProductsSelect ? 1 : quantity;

        let formData = {
            'items': [{
                id: currentProductId,
                quantity: quantityToSubmit,
                selling_plan: parseInt(checkedRadio.value)
            }]
        };

        return fetch(`/cart/add.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then((response) => response.json())
        .then(data => {
            if (redirect) {
                window.location.href = '/checkout';
            } else {
                return data;
            }
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }
}

window.checkoutFunctions = window.checkoutFunctions ? {
    ...window.checkoutFunctions,
    productPageCheckoutFn: goCheckout,
} : {
    productPageCheckoutFn: goCheckout,
};

class ProductSelector extends HTMLElement{
    constructor(){
        super();

        this.select = this.querySelector('select');
    }

    connectedCallback(){
        this.setProductId();

        this.select.addEventListener('change', () => {
            this.setProductId();

            const activeOption = this.select.options[this.select.selectedIndex];
            this.setActiveFormRadios(activeOption.dataset.index);
        })

    }

    setProductId(){
        currentProductId = parseInt(this.select.value);
    }

    setActiveFormRadios(index){
        const allRadios = document.querySelectorAll('.custom-recharge-form-radios')

        allRadios.forEach(radio => {
            if(radio.dataset.index === index){
                radio.classList.remove('hidden');

                const radioInputs =  radio.querySelectorAll('input');

                radioInputs[1].checked = true;
            }
            else{
                radio.classList.add('hidden');
            }
        })
    }
}

customElements.define('product-selector', ProductSelector);
